export default "__VITE_ASSET__ZbYAxg9y__"